import { ResourceRegionType } from '#shared';

export type LonLat = [number, number];
export type Alignment = 'left' | 'right';
type HubsAnchor = Record<string, { lonLat: LonLat; alignment: Alignment }>;

export const hubAnchors: HubsAnchor = {
  // US. East
  ATL: { lonLat: [-77, 29.8], alignment: 'right' },
  TPA: { lonLat: [-77.5, 26.3], alignment: 'right' },
  HOU: { lonLat: [-93.2, 25.8], alignment: 'right' },
  MCI: { lonLat: [-88, 25.55], alignment: 'right' },
  MSP: { lonLat: [-93, 49.1], alignment: 'right' },
  CHI: { lonLat: [-86.8, 48], alignment: 'right' },
  NYC: { lonLat: [-69, 38.3], alignment: 'right' },
  PHL: { lonLat: [-71, 35.3], alignment: 'right' },
  YIP: { lonLat: [-81.5, 46], alignment: 'right' },
  DUR: { lonLat: [-73.5, 32.6], alignment: 'right' },
  AND: { lonLat: [-66.6, 41.1], alignment: 'right' },
  CLE: { lonLat: [-76, 44.5], alignment: 'right' },
  // US. West
  DAL: { lonLat: [-102, 25.6], alignment: 'left' },
  APA: { lonLat: [-107, 28.5], alignment: 'left' },
  SAN: { lonLat: [-119.5, 29], alignment: 'left' },
  SLC: { lonLat: [-126, 39.5], alignment: 'left' },
  SEA: { lonLat: [-126.5, 43], alignment: 'left' },
  PHX: { lonLat: [-113.5, 28.5], alignment: 'left' },
  LOS: { lonLat: [-123, 32], alignment: 'left' },
  SFO: { lonLat: [-125.7, 35.2], alignment: 'left' },

  // ── Europe / Italy ───────────────────────────
  MLN: { lonLat: [6, 44], alignment: 'left' },
  BOL: { lonLat: [15, 43], alignment: 'right' },
  ROM: { lonLat: [11, 38], alignment: 'left' },
  BAR: { lonLat: [19, 40], alignment: 'right' },

  // ── Europe / Netherlands ─────────────────────
  UTR: { lonLat: [1.5, 50], alignment: 'left' },
};

export const surgeonGroupAnchors: Record<
  ResourceRegionType,
  Array<{ lonLat: LonLat; alignment: Alignment; dx?: number; dy?: number }>
> = {
  [ResourceRegionType.West]: [
    { lonLat: [-127.5, 46.5], alignment: 'right', dx: 0, dy: 0 }, // WE
  ],
  [ResourceRegionType.North]: [
    { lonLat: [-99.5, 49.5], alignment: 'left', dx: 0, dy: 0 }, // MW
  ],
  [ResourceRegionType.South]: [
    { lonLat: [-108, 26], alignment: 'right', dx: 0, dy: 0 }, // TX
  ],
  [ResourceRegionType.East]: [
    { lonLat: [-65, 44.5], alignment: 'left', dx: 0, dy: 0 }, // NE
    { lonLat: [-78.3, 23.7], alignment: 'left', dx: 0, dy: 0 }, // SE
  ],
};
